"use client"

import { useState } from "react"
import { Card } from "@/shared/components/ui/card"
import { Play, X } from "lucide-react"

const videos = [
  {
    title: "Como crear una admisión y generar sus Rips Json",
    description:
      "Conoce como crear tu primera admision y generar sus rips.",
    thumbnail: "/video1.png",
    duration: "1:26",
    url: "https://www.youtube.com/embed/pObGbQ0zHmE",
  },
  {
    title: "Como crear una cuenta en rapyfact",
    description: "Aprende a como crar tu cuenta de manera rapida y sencilla",
    thumbnail: "/video2.png",
    duration: "1:00",
    url: "https://www.youtube.com/embed/UVxe4B8UVJE",
  },
  {
    title: "Cómo Registrar un Doctor en tu cuenta Rapyfact",
    description: "Guía paso a paso para crear un doctor",
    thumbnail: "/video3.png",
    duration: "1:34",
    url: "https://www.youtube.com/embed/AybLsSJLC3c",
  },
  {
    title: "Como registrar una entidad en tu app de Rapyfact",
    description: "¿Quieres aprender a crear una entidad en Rapyfact de manera rápida y sencilla? En este video, te guiaré paso a paso para que configures tu entidad correctamente y sin errores. 💡",
    thumbnail: "/video4.png",
    duration: "1:54",
    url: "https://www.youtube.com/embed/W--TDneyg7M",
  },
]

export function VideosPage() {
  const [selectedVideo, setSelectedVideo] = useState<{
    title: string
    url: string
  } | null>(null)

  return (
    <div className="pt-32 pb-20 lg:pt-40 lg:pb-32 bg-background">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Encabezado */}
        <div className="text-center max-w-3xl mx-auto mb-16 animate-fade-in">
          <h1 className="text-4xl lg:text-6xl font-bold mb-6 text-foreground">
            Videos Tutoriales
          </h1>
          <p className="text-lg lg:text-xl text-muted-foreground">
            Aprende a usar <span className="text-primary font-semibold">Rapyfact</span> con nuestros videos paso a paso
          </p>
        </div>

        {/* Grid de videos */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {videos.map((video, index) => (
            <Card
              key={index}
              onClick={() => setSelectedVideo(video)}
              className="overflow-hidden hover:shadow-2xl hover:shadow-primary/10 transition-all duration-500 hover:scale-105 group cursor-pointer animate-scale-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="relative aspect-video bg-muted">
                <img
                  src={video.thumbnail || "/placeholder.svg"}
                  alt={video.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-16 h-16 rounded-full bg-primary flex items-center justify-center shadow-lg shadow-primary/30">
                    <Play className="w-8 h-8 text-white ml-1" />
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 bg-black/80 text-white text-xs px-2 py-1 rounded">
                  {video.duration}
                </div>
              </div>
              <div className="p-6 space-y-2">
                <h3 className="text-xl font-bold text-foreground">{video.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{video.description}</p>
              </div>
            </Card>
          ))}
        </div>
      </div>

      {/* ✅ Modal para reproducir el video */}
      {selectedVideo && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4 animate-in fade-in duration-200">
          <div className="relative w-full max-w-5xl aspect-video bg-black rounded-xl overflow-hidden shadow-2xl">
            <button
              onClick={() => setSelectedVideo(null)}
              className="absolute top-3 right-3 z-10 bg-white/10 hover:bg-white/20 text-white rounded-full p-2 transition-colors"
            >
              <X className="w-6 h-6" />
            </button>
            <iframe
              src={`${selectedVideo.url}?autoplay=1`}
              title={selectedVideo.title}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="w-full h-full rounded-xl"
            ></iframe>
          </div>
        </div>
      )}
    </div>
  )
}
